export default defineNuxtRouteMiddleware((to) => {
  if (!to.path.startsWith('/partners/')) return

  const runtimeConfig = useRuntimeConfig()
  const isLocal = (runtimeConfig.public.env || 'local') === 'local'

  const affLinkCookie = useCookie<string | null>('affLinkId', {
    secure: !isLocal,
    sameSite: isLocal ? 'lax' : 'none',
    domain: isLocal ? undefined : '.usimsa.com',
    path: '/'
  })

  affLinkCookie.value = null
})
